import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useRecoilState } from "recoil";
import Form from "react-bootstrap/Form";
import { DebounceInput } from "react-debounce-input";
import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";
import OverrideAbleTip from "app/components/ProductionScenario/OverrideAbleTip";

import {
  CCPolySystemToCustomerData,
  CCPolyPowderToCustomerData,
  CCPolyMaterialTransportationData,
  CCPolySystemTransportationData,
  CCPolyCarbonEmissionFactorNode1Data,
  CCPolyCarbonEmissionFactorNode2Data,
  CCPolyCo2ePerYearData,
  CCPolyCo2ePerPartTPData,
} from "atoms/CCPolymer/CCPolyTransportation";

import { useRoundOffValue } from "app/components/hooks/useRoundOffValue";
import { ProcessFlag } from "atoms/General";

const Transportation = ({ Socket, StepID }) => {
  const [systemToCustomer, setSystemToCustomer] = useRecoilState(
    CCPolySystemToCustomerData
  );
  const [materialTransportaion, setMaterialTransportaion] = useRecoilState(
    CCPolyMaterialTransportationData
  );
  const [systemTransportation, setSystemTransportation] = useRecoilState(
    CCPolySystemTransportationData
  );
  const [powderToCustomer, setPowderToCustomer] = useRecoilState(
    CCPolyPowderToCustomerData
  );
  const [cefnone, setCefnOne] = useRecoilState(
    CCPolyCarbonEmissionFactorNode1Data
  );
  const [cefnTwo, setCefnTwo] = useRecoilState(
    CCPolyCarbonEmissionFactorNode2Data
  );
  const [co2PerYear, setCo2PerYear] = useRecoilState(CCPolyCo2ePerYearData);
  const [co2PerPart, setCo2PerPart] = useRecoilState(CCPolyCo2ePerPartTPData);
  const { getComputedValue } = useRoundOffValue();
  const [, setProcessFlag] = useRecoilState(ProcessFlag);

  const costData = JSON.parse(localStorage.getItem("CostData"));
  const [loader, setLoader] = useState({
    loaderone: false,
    loadertwo: false,
    loaderthree: false,
    loaderfour: false,
  });
  useEffect(() => {
    if (powderToCustomer) {
      Socket.off("*");
      setLoader((prevState) => {
        return {
          ...prevState,
          loaderone: true,
        };
      });

      Socket.emit("carbon-calculator", {
        key: "DBCC-CEFN1",
        input: { powder_to_customer: powderToCustomer },
      });

      Socket.on("DBCC-CEFN1", function (data) {
        setCefnOne(data?.data?.value);
        setLoader((prevState) => {
          return {
            ...prevState,
            loaderone: false,
          };
        });
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [powderToCustomer]);
  useEffect(() => {
    if (systemToCustomer) {
      Socket.off("*");
      setLoader((prevState) => {
        return {
          ...prevState,
          loadertwo: true,
        };
      });

      Socket.emit("carbon-calculator", {
        key: "DBCC-CEFN2",
        input: { system_to_customer: systemToCustomer },
      });

      Socket.on("DBCC-CEFN2", function (data) {
        setCefnTwo(data?.data?.value);
        setLoader((prevState) => {
          return {
            ...prevState,
            loadertwo: false,
          };
        });
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemToCustomer]);
  useEffect(() => {
    if (materialTransportaion && systemTransportation && cefnone && cefnTwo) {
      Socket.off("*");
      setLoader((prevState) => {
        return {
          ...prevState,
          loaderthree: true,
        };
      });

      Socket.emit("carbon-calculator", {
        key: "FOCC-TPCPY",
        input: {
          material_transportation: +materialTransportaion,
          system_transportation: +systemTransportation,
          carbon_emission_factor_node_1: +cefnone,
          carbon_emission_factor_node_2: +cefnTwo,
        },
      });

      Socket.on("FOCC-TPCPY", function (data) {
        const value = getComputedValue(data?.data?.value);

        setCo2PerYear(value);
        setLoader((prevState) => {
          return {
            ...prevState,
            loaderthree: false,
          };
        });
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    systemTransportation,
    materialTransportaion,
    systemTransportation,
    cefnone,
    cefnTwo,
  ]);

  useEffect(() => {
    if (
      co2PerYear &&
      +costData.utilization.value &&
      +costData.build_time.value &&
      +costData.setup_time.value &&
      +costData.unpacking_time_per_job.value &&
      +costData.cool_down_time_in_system.value &&
      +costData.technology_id.value
    ) {
      Socket.off("*");
      setLoader((prevState) => {
        return {
          ...prevState,
          loaderfour: true,
        };
      });

      Socket.emit("carbon-calculator", {
        key: "FOCC-TPCPPMP",
        input: {
          co2e_per_year: +co2PerYear,
          utilization: +costData.utilization.value,
          build_time: +costData.build_time.value,
          setup_time: +costData.setup_time.value,
          unpacking_time_per_job: +costData.unpacking_time_per_job.value,
          cool_down_time_in_system: +costData.cool_down_time_in_system.value,
          technology_id: +costData.technology_id.value,
        },
      });

      Socket.on("FOCC-TPCPPMP", function (data) {
        const value = getComputedValue(data?.data?.value);

        setCo2PerPart(value);
        setLoader((prevState) => {
          return {
            ...prevState,
            loaderfour: false,
          };
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [co2PerYear]);

  // Component Returning Content...
  useEffect(() => {
    if (
      powderToCustomer != null &&
      systemToCustomer != null &&
      materialTransportaion != null &&
      systemTransportation != null &&
      cefnone != null &&
      cefnTwo != null &&
      co2PerYear != null &&
      co2PerPart != null
    ) {
      setProcessFlag((prevState) => {
        return {
          ...prevState,
          Transportation: true,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    powderToCustomer,
    systemToCustomer,
    materialTransportaion,
    systemTransportation,
    cefnone,
    cefnTwo,
    co2PerYear,
    co2PerPart,
  ]);

  return (
    <>
      <div className="field-wrapper flex-item">
        <p className="input-heading">Powder to customer </p>

        <div className="input-section">
          <Form.Control
            onChange={(e) => setPowderToCustomer(e.target.value)}
            as="select"
            aria-label="Default Control example"
          >
            <option className="select-option">Please select method</option>
            <option
              value="Rail"
              selected={powderToCustomer === "Rail" && "selected"}
              className="select-option"
            >
              Rail
            </option>
            <option
              value="Road"
              selected={powderToCustomer === "Road" && "selected"}
              className="select-option"
            >
              Road
            </option>
            <option
              value="Air"
              selected={powderToCustomer === "Air" && "selected"}
              className="select-option"
            >
              Air
            </option>
            <option
              value="ship"
              selected={powderToCustomer === "Ship" && "selected"}
              className="select-option"
            >
              Ship
            </option>
          </Form.Control>
          <img src="../assets/arrow-down.png" alt="" className="edit-icon" />
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">System to customer </p>
        <div className="input-section">
          <Form.Control
            onChange={(e) => {
              setSystemToCustomer(e.target.value);
            }}
            as="select"
            aria-label="Default Control example"
          >
            <option className="select-option">Please select method</option>
            <option
              value="Rail"
              selected={systemToCustomer === "Rail" && "selected"}
              className="select-option"
            >
              Rail
            </option>
            <option
              value="Road"
              selected={systemToCustomer === "Road" && "selected"}
              className="select-option"
            >
              Road
            </option>
            <option
              value="Air"
              selected={systemToCustomer === "Air" && "selected"}
              className="select-option"
            >
              Air
            </option>
            <option
              value="Ship"
              selected={systemToCustomer === "Ship" && "selected"}
              className="select-option"
            >
              Ship
            </option>
          </Form.Control>
          <img src="../assets/arrow-down.png" alt="" className="edit-icon" />
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">
          <TooltipTrippy
            tooltipMessage="This refers to the distance the powder travels to
              reach your production site; for an estimation, you can use google
              maps setting the initial location to Maisach, Germany, and
              destination as your production facility to then insert the km in
              the input field here."
            fieldName="Powder logistics (km)"
          />
        </p>
        <div className="input-section">
          <DebounceInput
            type="number"
            className="user-input"
            debounceTimeout={500}
            onChange={(e) => {
              setMaterialTransportaion(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            placeholder="Please enter the distance for powder logistics"
            value={materialTransportaion}
          />
          <OverrideAbleTip />
          {/* <p className="edit-icon value-unit">km</p> */}
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">
          <TooltipTrippy
            tooltipMessage="This refers to the distance the system travels to
              reach your production site, for an estimation, you can use google
              maps setting the initial location to Maisach, Germany, and
              destination as your production facility to then insert the km in
              the input field here."
            fieldName="System logistics (km)"
          />
        </p>
        <div className="input-section">
          <DebounceInput
            type="number"
            className="user-input"
            debounceTimeout={500}
            onChange={(e) => {
              setSystemTransportation(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            placeholder="Please enter the distance for system logistics"
            value={systemTransportation}
          />
          <OverrideAbleTip />
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">Carbon emission factor node 1 (kg/km)</p>
        <div className="input-section">
          <DebounceInput
            type="number"
            className="user-input"
            debounceTimeout={500}
            onChange={(e) => {
              setCefnOne(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            placeholder="Please enter CO2e per job"
            value={
              loader.loaderone ? (
                <Spinner animation="border" size="sm" />
              ) : (
                cefnone
              )
            }
          />
          <OverrideAbleTip />
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">Carbon emission factor node 2 (kg/km)</p>
        <div className="input-section">
          <DebounceInput
            type="number"
            className="user-input"
            debounceTimeout={500}
            onChange={(e) => {
              setCefnTwo(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            placeholder="Please enter CO2e per job"
            value={
              loader.loadertwo ? (
                <Spinner animation="border" size="sm" />
              ) : (
                cefnTwo
              )
            }
          />
          <OverrideAbleTip />
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">CO2e per year (kg) </p>
        <div className="data-field">
          {loader.loaderthree ? (
            <Spinner animation="border" size="sm" />
          ) : (
            co2PerYear
          )}
        </div>
      </div>
      <div className="field-wrapper flex-item">
        <p className="input-heading">CO2e per part (kg) </p>
        <div className="data-field">
          {loader.loaderfour ? (
            <Spinner animation="border" size="sm" />
          ) : (
            co2PerPart
          )}
        </div>
      </div>
    </>
  );
};

export default Transportation;
